import React, { Component } from 'react'
import { Icon } from '@softwaredev_cegeka/stix-core'
import { Input } from '@softwaredev_cegeka/stix-form'

class DataTableHeaderSearch extends Component {
    handleSearchChange = inputValue => {
        if (this.props.handleSearchChange) {
            this.props.handleSearchChange(inputValue?.target?.value)
        }
    }

    render() {
        return (
            <>
                <Input
                    srOnly
                    placeholder={'Search'}
                    label={'Search'}
                    onChange={this.handleSearchChange}
                />
                <Icon icon="search" />
            </>
        )
    }
}

export default DataTableHeaderSearch
